import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import './ProductSidebarQuestins.scss';
import {useConfig} from "../../../context/ConfigContext";
import {useTranslation} from "react-i18next";
import { T } from '../../../utils/I18n/I18n';
import Popup from '../../UI/Popup/Popup';
import ProductQuestionsPopup from './ProductQuestionsPopup';



const ProductSidebarQuestions = ({ sku, name }) => {
    const { t } = useTranslation();
    const { config } = useConfig();
    const phoneSupportNumber = config?.phoneSupportNumber;
    const countryCode = config?.countryCode || 'hr-HR';
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [shouldRender, setShouldRender] = useState(false);

    const handleLinkClick = (e) => {
        e.preventDefault();
        setIsPopupOpen(true);
        // Opóźnij renderowanie zawartości, aby popup się otworzył płynnie
        setTimeout(() => setShouldRender(true), 50);
    };

    const handleClose = () => {
        setIsPopupOpen(false);
        setShouldRender(false);
    };

    return (
    <div className="sidebar-questions">

      <div>
        <T id="product.haveQuestion" />

          {countryCode === 'hr-HR' && (
          <div>
              {' '}
              {t('product.askQuestion')}
                &nbsp;
              <a
                href="#"
                onClick={handleLinkClick}
                className="sidebar-questions__link"
                rel="nofollow"
              >
                  {t('product.online')}
              </a>
          </div>
          )}
      </div>
      <br />
        {countryCode === 'hr-HR' && (
            <div>
                <T id="product.checkAvailability" />
                <b>
                    &nbsp;
                    {t('product.ourStores')}
                    &nbsp;
                </b>
                <T id="product.callNumber" /> <a className="sidebar-questions__link__number" href={`tel:${phoneSupportNumber}`}>{phoneSupportNumber}</a>.
                <br/>
                <strong><small><T id="product.callCenterOpeningHours" /></small></strong>
            </div>
        )}
        {countryCode === 'sr-RS' && (
            <div>
                <T id="product.askQuestion"/>
                {' '}
                <a
                    href="#"
                    onClick={handleLinkClick}
                    className="sidebar-questions__link"
                    rel="nofollow"
                >
                    <T id="product.online" />
                </a>
                {' '}
                <T id="product.OrCall" />
                {' '}
                <a className="sidebar-questions__link__number" href={`tel:${phoneSupportNumber}`}>{phoneSupportNumber}</a>.
                <br />
                <small><T id="product.callPriceSideBar" /></small>
            </div>
        )}

        <Popup
            isOpen={isPopupOpen}
            onClose={handleClose}
            title={t('product.askQuestion')}
        >
            {shouldRender && <ProductQuestionsPopup productSku={sku} productName={name} onFormSubmitSuccess={handleClose} />}
        </Popup>
    </div>
    );
};

ProductSidebarQuestions.propTypes = {
  sku: PropTypes.string,
  name: PropTypes.string,
};

export default memo(ProductSidebarQuestions);
